// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__33lir","head":"Table_head__1BxWK","col":"Table_col__3EbWS"};